/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MoveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconArrowForward from 'DesignSystem/Svgs/TysiaIconArrowForward/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MoveAction({
  children,
  viewPath = "/App/Account/Content/Tasks/New/TaskOverlay/Content/Content/Comms/Content/MoveAction",
  isHovered
  
}) {
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let selectedCommsDockedLeftValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.docked_left',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
let selectedCommsDockedLeftValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.docked_left',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="MoveAction.Vertical"
  data-view-path={viewPath}
 style={{'--r-1-Z8vNVE': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 size="small"
 onClick={onClick}
 title={selectedCommsDockedLeftValueData ? "Dock to the right" : "Dock to the left"}
 data="selected.comms.docked_left"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<div
  data-testid="MoveAction.Vertical:1"
  data-view-path={viewPath}
 style={{'--r-2-Z8vNVE': selectedCommsDockedLeftValueData1 ? "0deg" : "180deg"}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaIconArrowForward
  viewPath={`${viewPath}/TysiaIconArrowForward`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill={childProps.isHovered ? dtColorsNeutral500 : dtColorsNeutral400}
/>
</div>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
</div>
{children}
</React.Fragment>)
}